export default __webpack_public_path__ + "static/media/photo_profile_default.e58ecfb9.svg";